import { createSelector } from 'reselect';
import { updatedSummitBenefitsEnabled } from 'services/FeatureFlags';
import {
  CORE,
  SELECT,
  PERSONAL_SERVICES,
  ENHANCED_PERSONAL_SERVICES,
  SELECT_MIN_AMOUNT,
  PS_MIN_AMOUNT,
  EPS_MIN_AMOUNT,
  summitMembershipMapById
} from 'services/HouseholdInformationCard';

const getHouseholdInformation = (state) => state.householdInformation || {};

export const getAssetBalance = createSelector(
  getHouseholdInformation,
  (household) => household.assetBalance
);

export const getAssetId = createSelector(
  getHouseholdInformation,
  (household) => household.assetId
);

export const hasAssetId = createSelector(
  getAssetId,
  (id) =>
    id === CORE ||
    id === SELECT ||
    id === PERSONAL_SERVICES ||
    id === ENHANCED_PERSONAL_SERVICES
);

export const getTierMaximum = createSelector(
  getHouseholdInformation,
  (household) => household.tierMaximum
);

export const isEPSClient = createSelector(
  getAssetId,
  (id) => id === ENHANCED_PERSONAL_SERVICES
);

export const getNextTierId = createSelector(
  getHouseholdInformation,
  (household) => household.nextTierAssetId
);

export const getNextTierName = createSelector(
  getNextTierId,
  (nextTierId) => summitMembershipMapById[nextTierId]
);

export const getNextTierMinimum = createSelector(getAssetId, (currentTier) => {
  switch (currentTier) {
    case CORE:
      return SELECT_MIN_AMOUNT;
    case SELECT:
      return PS_MIN_AMOUNT;
    case PERSONAL_SERVICES:
      return EPS_MIN_AMOUNT;
    case ENHANCED_PERSONAL_SERVICES:
      return null;
    default:
      return SELECT_MIN_AMOUNT;
  }
});

export const hasKiplingerAccess = createSelector(
  getHouseholdInformation,
  (household) =>
    household && household.kiplingerAccess ? household.kiplingerAccess : false
);

export const hasMorningstarAccess = createSelector(
  getHouseholdInformation,
  (household) =>
    household && household.morningstarAccess
      ? household.morningstarAccess
      : false
);

export const getBalanceReportDate = createSelector(
  getHouseholdInformation,
  (household) => household.balanceReportDate
);

export const getHouseholdMembers = createSelector(
  getHouseholdInformation,
  (household) => household.householdMembers
);

export const getHouseholdMemberNames = createSelector(
  getHouseholdMembers,
  (householdMembers) => {
    if (!householdMembers) {
      return [];
    }
    return householdMembers && householdMembers.map(
      member => member.name
    );
  }
);

export const showHouseholdDetails = () => updatedSummitBenefitsEnabled();
